import React, { useRef } from "react";
import { SDrawerOrModal, SLowcodeList, STags } from "shj-components";

import { getCombinationSkuList } from "@/services/product.ts";
import { config } from './config.jsx'
import { apiData2Table } from "@/utils/data.ts";

const SKUDetailModal = (props) => {
  const { open, onClose, record = {} } = props;
  const listRef = useRef();

  const fetchList = ({current, pageSize, query }) => {
    if (!record.id) return Promise.reject()
    return new Promise((resolve, reject) => {
      getCombinationSkuList(record.id, {
        data: { ...query, queryShops: true },
        params: {
          pageId: current,
          pageSize: pageSize,
        },
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(err => {
        reject(err)
      })
    })
  }

  const extension = {
    request: { fetchList },
    rowKey: 'id',
    customRender: {
      nameRender(v) {
        return <div style={{ maxWidth: 200, whiteSpace: 'wrap', wordBreak: 'break-all' }}>{v}</div>
      },
      shopNameRender(v) {
        const names = v?.map?.(item => item.companyName)
        return names?.join?.(', ')
      },
      enabledRender(v) {
        return <STags
          itemKey=""
          label={v ? '启用' : '禁用'}
          fontColor={v ? '#00A865' : '#EB3723'}
          bgColor={v ? '#D7F7EA' : '#FFEAE8'}
        />
      },
    }
  }

  return <>
    <SDrawerOrModal
      title={'SKU详情'}
      width={900}
      open={open}
      loading={false}
      onCancel={onClose}
      antdProps={{
        footer: null
      }}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
    </SDrawerOrModal>
  </>
}

export default SKUDetailModal